import { Link } from 'react-router-dom';
import { Banknote, ConciergeBell, Handshake, LifeBuoy, MessagesSquare, type LucideIcon } from 'lucide-react';

type Recipe = { to: string; icon: LucideIcon; name: string; job: string };

const RECIPES: Recipe[] = [
  {
    to: '/admin/recetas/asistente',
    icon: MessagesSquare,
    name: 'Asistente',
    job: 'Responde las consultas de siempre con lo que la empresa le cuenta.',
  },
  {
    to: '/admin/recetas/vendedor',
    icon: Handshake,
    name: 'Vendedor',
    job: 'Atiende a los interesados, averigua lo que importa y pasa los buenos a ventas.',
  },
  {
    to: '/admin/recetas/cobrador',
    icon: Banknote,
    name: 'Cobrador',
    job: 'Contacta a los deudores, informa la deuda y registra promesas de pago.',
  },
  {
    to: '/admin/recetas/mesa',
    icon: LifeBuoy,
    name: 'Mesa de ayuda',
    job: 'Recibe problemas, abre un ticket y llama a una persona cuando hace falta.',
  },
  {
    to: '/admin/recetas/conserje',
    icon: ConciergeBell,
    name: 'Conserje',
    job: 'Va al frente de los demás: saluda y pasa cada persona al agente que corresponde.',
  },
];

export function RecipesHubPage() {
  return (
    <div className='mx-auto w-full max-w-2xl px-4 py-8 sm:py-12'>
      <header className='mb-8'>
        <h1 className='text-3xl font-semibold tracking-tight text-foreground'>Crear un agente</h1>
        <p className='mt-2 max-w-prose text-base text-muted-foreground'>
          Elegí qué tiene que hacer. Con dos o tres respuestas queda listo; todo lo demás viene configurado.
        </p>
      </header>
      <ul className='divide-y divide-border border-y border-border'>
        {RECIPES.map(recipe => (
          <li key={recipe.to}>
            <Link
              to={recipe.to}
              className='group flex items-start gap-4 py-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
            >
              <span className='mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary'>
                <recipe.icon className='h-5 w-5' aria-hidden />
              </span>
              <span className='min-w-0'>
                <span className='block text-base font-semibold text-foreground group-hover:text-primary'>
                  {recipe.name}
                </span>
                <span className='block text-sm text-muted-foreground'>{recipe.job}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
